// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Curry from "melange.js/curry.js";

function make(onOpenOpt, onError, onClose, address) {
  const onOpen = onOpenOpt !== undefined ? onOpenOpt : (function (param) {
      
    });
  const ws = new WebSocket(address);
  Belt__Belt_Option.forEach(onError, (function (onerror) {
    ws.onerror = onerror;
  }));
  Belt__Belt_Option.forEach(onClose, (function (onclose) {
    ws.onclose = onclose;
  }));
  ws.onopen = (function (param) {
    Curry._1(onOpen, ws);
  });
  return ws;
}

export {
  make,
}
/* No side effect */
